import { Navigate } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";
import {
  DEFAULT_DASHBOARD_ANALYTICS_SLUG,
  dashboardAnalyticsHref,
} from "@/shared/navigation/analyticsNav";
import { isAdminRole, isStoreManagerRole } from "@/shared/utils/roles";

export function HomeEntryRedirect() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (isStoreManagerRole(user?.role)) {
    return <Navigate to="/orders" replace />;
  }

  // Admins land on the journey analytics home; everyone else on the Overview.
  if (isAdminRole(user?.role)) {
    return <Navigate to={dashboardAnalyticsHref(DEFAULT_DASHBOARD_ANALYTICS_SLUG)} replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
